<div class="mt-5 pt-5" id="managePeerToPeerPage" #managePeerToPeerPage style="background-color: HSL(225, 40%, 98%);">
    <app-header title="Peer to Peer Report"></app-header>
    
    <app-peer-to-peer-list></app-peer-to-peer-list>
</div>